import React from "react";
import { Link } from "react-router-dom";

const encodePath = (label) => label.replace(/\//g, "~");

const Breadcrumb = ({ pathSegments = [] }) => {
  if (!pathSegments.length) return null;

  return (
    <div className="flex items-center gap-2 text-sm text-gray-600">
      {pathSegments.map((segment, idx) => {
        const fullPath = pathSegments
          .slice(0, idx + 1)
          .map(encodePath)
          .map(encodeURIComponent)
          .join("/");

        return (
          <span key={idx} className="flex items-center gap-1">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="rgba(60,60,60,1)">
              <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path>
            </svg>
            <Link to={`/${fullPath}`} className="hover:text-blue-500 hover:underline whitespace-pre">
              {segment}
            </Link>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
